import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgProgress } from '@ngx-progressbar/core';
import { map } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { AppState } from '../../services/app.service';
import { UserService } from '../../dataServices/userService';
import { Vehicle } from './verification-tractors.model';
import { PdfReportService, PdfResponse } from '../../services/pdfReport.service';
import { LinkService } from '../../services/link.service';
import { User } from '../../models/user';
import { QuoteByUserId } from 'src/app/models/quotes';

@Component({
    selector: 'self-ins-verification-tractors',
    templateUrl: './verification-tractors-page.component.html',
    styleUrls: ['./verification-tractors-page.component.scss']
})
export class VerificationTractorsPageComponent implements AfterViewInit {
    @ViewChild(MatSort) public sort: MatSort | undefined;
    public user: User = this.appState.user.getValue();
    public gridFilterValue = '';
    public displayedColumns = ['vin', 'year', 'make', 'equipmentId', 'fuelType', 'pickupDate', 'insuranceEffDate', 'insuranceTermDate'];
    public tractors = new MatTableDataSource<Vehicle>([]);
    public allVehiclesPdf: PdfResponse | null = null;
    public qnum: number = 0;
    public qsuffix: string = '';
    public constructor(private router: Router,
                       private activeRouter: ActivatedRoute,
                       private appState: AppState,
                       private userService: UserService,
                       private pdfReportService: PdfReportService,
                       private progressBar: NgProgress,
                       private linkService: LinkService) {
        

        if (this.user?.status === 'active') {
            this.displayedColumns.push('action');
        }

        this.activeRouter.queryParams.subscribe(params => {
            this.qnum = params['qnum'];
            this.qsuffix = params['qsuffix'];
        
            this.progressBar.ref().start();
            this.userService.getVehicles(this.qnum, this.qsuffix)
                .pipe(
                    finalize(() => this.progressBar.ref().complete())
                )
                .subscribe({
                    next: (x) => {
                        this.tractors.data = x.sort((a, b) => {
                            return Number(new Date(b.pickupDate)) - Number(new Date(a.pickupDate))
                        }).map((t) => {
                            t.allowDownload = t.insuranceTermDate ? new Date(t.insuranceTermDate) >= new Date() : true;
                            return t;
                        });
                    }
                });
        });
    }

    ngAfterViewInit() {
        this.tractors.sort = this.sort || null;
    }

    downloadIdCards() {
        if (this.allVehiclesPdf) {
            this.downloadFile(this.allVehiclesPdf);
            return;
        }
        this.progressBar.ref().start();
        this.pdfReportService.getVehiclesPdf(this.qnum, this.qsuffix)
            .pipe(
                map((r) => ({ content: r.content, name: 'ID_Cards.pdf' })),
                finalize(() => this.progressBar.ref().complete())
            ).subscribe((cert) => {
                this.allVehiclesPdf = cert;
                this.downloadFile(cert);
            })
    }

    downloadIdCard(tractor: Vehicle) {
        if (tractor.certificate) {
            this.downloadFile(tractor.certificate);
            return;
        }
        this.progressBar.ref().start();
        this.pdfReportService.getVehiclePdf(this.qnum, this.qsuffix, tractor.id)
            .pipe(
                map((r) => ({ content: r.content, name: `ID_Card_${tractor.vin}.pdf` })),
                finalize(() => this.progressBar.ref().complete())
            ).subscribe((cert) => {
                this.tractors.data.map((t) => {
                    if (t.id === tractor.id) {
                        t.certificate = cert;
                    }
                })
                this.downloadFile(cert);
        })
    }

    applyFilter() {
        this.tractors.filter = this.gridFilterValue.trim().toLowerCase();
    }

    public downloadFile(data: PdfResponse) {
        this.linkService.openBlob(
            data.content as ArrayBuffer, { description: data.name });
    }

    public onSubmit() {
        this.router.navigate(['/verification-drivers', this.qnum, this.qsuffix]);
    }
}
